var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-rows"},[_c('img',{class:{'m-0' : _vm.noText},attrs:{"src":require("../../../../assets/images/empty-widget.svg"),"alt":""}}),_c('p',[(!_vm.noText)?_vm._t("default",[_vm._v("Nothing to see here yet")]):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }